{
  "name": "client",
  "version": "1.1.0",
  "license": "MIT",
  "private": true,
  "scripts": {
    "start": "ng serve client-app --hmr --port 4204 --host 0.0.0.0",
    "start:team": "ng serve team-app --hmr --port 4201 --host 0.0.0.0",
    "test:client": "npm run test:typecheck && jest --config jest.config.ts",
    "test:team": "npm run test:typecheck:team && jest --config jest.team.config.ts",
    "test:typecheck:team": "tsc -p tsconfig.team.spec.json --noEmit --pretty false",
    "ng": "ng",
    "build:client-app:local": "ng build client-app --configuration=local",
    "build:client-app:dev": "ng build client-app --configuration=dev",
    "build:client-app:staging": "ng build client-app --configuration=staging",
    "build:client-app:prod": "ng build client-app --configuration=prod",
    "build:team-app:local": "ng build team-app --configuration=local",
    "build:team-app:dev": "ng build team-app --configuration=dev",
    "build:team-app:staging": "ng build team-app --configuration=staging",
    "build:team-app:prod": "ng build team-app --configuration=prod",
    "lint": "npm --prefix .. run lint:eslint:client",
    "lint:fix": "npm --prefix .. run lint:eslint:client -- --fix",
    "lint:client": "npm --prefix .. exec eslint -- shared projects/client-app",
    "lint:client:fix": "npm --prefix .. exec eslint -- --fix shared projects/client-app",
    "lint:team": "npm --prefix .. exec eslint -- shared projects/team-app",
    "lint:team:fix": "npm --prefix .. exec eslint -- --fix shared projects/team-app",
    "i18n:check": "node ../scripts/check-translations.js && echo '' && node ../scripts/check-translation-placeholders.js",
    "test:typecheck": "tsc -p tsconfig.spec.json --noEmit --pretty false"
  },
  "dependencies": {
    "@angular/animations": "^21.2.0",
    "@angular/cdk": "^21.2.0",
    "@angular/common": "^21.2.0",
    "@angular/compiler": "^21.2.0",
    "@angular/core": "^21.2.0",
    "@angular/forms": "^21.2.0",
    "@angular/material": "^21.2.0",
    "@angular/material-moment-adapter": "^21.2.0",
    "@angular/platform-browser": "^21.2.0",
    "@angular/platform-browser-dynamic": "^21.2.0",
    "@angular/router": "^21.2.0",
    "@angular/service-worker": "^21.2.0",
    "@ngrx/component-store": "^21.0.1",
    "@ngx-translate/core": "15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@sentry/angular": "^10.14.0",
    "core-js": "3.36.0",
    "crisp-sdk-web": "^1.0.28",
    "date-fns": "^3.6.0",
    "font-awesome": "^4.7.0",
    "lodash": "^4.18.1",
    "mixpanel-browser": "^2.79.0",
    "moment": "^2.30.1",
    "ngx-google-analytics": "^14.0.1",
    "ngx-mask": "^17.0.4",
    "ngx-ui-tour-md-menu": "^16.0.0",
    "rxjs": "~7.8.1",
    "survey-creator-angular": "^2.5.25",
    "survey-creator-core": "^2.5.25",
    "tslib": "^2.6.2",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.0",
    "@angular/cli": "^21.2.0",
    "@angular/compiler-cli": "^21.2.0",
    "@angular/language-service": "21.2.0",
    "@angular/platform-server": "^21.2.0",
    "@testing-library/angular": "^19.0.0",
    "@testing-library/jest-dom": "^6.0.0",
    "@testing-library/user-event": "^14.0.0",
    "@types/jest": "^29.5.12",
    "@types/lodash": "^4.17.7",
    "@types/mixpanel-browser": "^2.60.0",
    "@types/node": "^18.19.18",
    "factory.ts": "^1.4.1",
    "jest": "^30.0.0",
    "jest-environment-jsdom": "^30.0.0",
    "jest-preset-angular": "^16.0.0",
    "ts-jest": "^29.0.0",
    "ts-node": "^10.9.2",
    "typescript": "^5.9.3"
  }
}
